module.exports = __webpack_public_path__ + "images/category_lp/tablet/assessment_achievements/1_bcadc7ee75c9298e19bbf770f944109a.jpg";